import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthMyfileService } from './auth.myfile.service';
import { GlobalComponent } from 'src/app/global-component';
import { timer } from 'rxjs'
import moment from 'moment';
import { LastActiveService } from './last-active.service';

/**
 * The User session tracker service tracks the activity/inactivity of a logged in user. 
 * If the user is inactive for a configured amount of time specified by GlobalComponent.defaultSessionInactivityTimeS the 
 * user will be logged out. This is done for security purposes.
 * This service also handles token refresh/renewal to maintain the user session.
 */
@Injectable({
  providedIn: 'root'
})
export class UserSessionTrackerService implements OnDestroy {
  
  private unsubscribe: Subscription[] = [];
  
  private timerTickMs: number = 30000; //every 30 seconds
  private inactivityLogoutTimeoutS: number = GlobalComponent.defaultSessionInactivityTimeS;

  private isLoggedIn: boolean = false;

  constructor(
    private authMyFileService: AuthMyfileService,
    private lastActiveService: LastActiveService) 
  {
    this.authMyFileService.loggedIn$.subscribe((result: boolean) => {
      this.isLoggedIn = result;
      if (this.isLoggedIn) {

        
        this.run();
      }
      else {
        this.stop();
      }
    });
  }
    
  private run() {
       
    const inactivitySubscr = timer(0, this.timerTickMs)
      //.pipe(filter(() => this.isLoggedIn))
      .subscribe(() => {
        const currentDate = moment(new Date());   
 
        const lastActiveDate = this.lastActiveService.getLastActiveDate();
        const diff = moment.duration(currentDate.diff(lastActiveDate)).asSeconds();

        if (diff > this.inactivityLogoutTimeoutS) {
          this.signOutUser(0);
        }
        else {
          this.authMyFileService.ping().subscribe();  
        }
      });

    this.unsubscribe.push(inactivitySubscr);

    var authModel = this.authMyFileService.getAuthFromLocalStorage();

    if (authModel && authModel.jwtAccessToken) {
      var expiresOnDate = authModel.jwtAccessToken.expiresOn;

      if (expiresOnDate) {
        const currentDate = moment(new Date());
        const tokenExpiryDate = moment(expiresOnDate); 
  
        const tokenRefreshIntervalMs = moment.duration(tokenExpiryDate.diff(currentDate)).asMilliseconds() - 30000;
  
        const tokenRefreshSubscr = timer(tokenRefreshIntervalMs, tokenRefreshIntervalMs)
          .subscribe(() => {
            this.authMyFileService.refreshAuthModel().subscribe();
          });
  
        this.unsubscribe.push(tokenRefreshSubscr);
      }
      
    }

    //synchronize the login state between different tabs
    // fromEvent<StorageEvent>(window, 'storage')
    //   .pipe(
    //     filter(event => event.storageArea === localStorage
    //       && event.key === this.localStorageKey),
    //     map(event => !!event.newValue)
    //   )
    //   .subscribe(loggedIn => {
    //     this.loggedIn.next(loggedIn);
    //   });
  }

  private stop() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  private renewToken() {
    console.log('renewToken');
    // this.userSessionData
    //     .getToken()
    //     .then(token => this.resetToken(token.data))
    //     .catch(() => this.redirectToSignin(userBlockTime));
  }

  private signOutUser(delayTime: number) {    
    this.removeAccessToken();

    setTimeout(() =>  this.authMyFileService.logout(), delayTime);
  }

  private removeAccessToken() {
    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  }

  private getCookie(name: string) {
      return (document.cookie.match('(^|;) *' + name + '=([^;]*)') || "")[2];
  }

  ngOnDestroy() {
    this.stop();
  }
}
